import React from 'react';

import '@Pages/RetroSynthesis/EditPlan/AddSteps/components/PlanNoResults.custom.scss';

const PlanNoResults = () => <div className="plan-no-results">No results found.</div>;

export default PlanNoResults;
